





























































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import Annoucement from "@/models/porposal/porposal.model";
import { BTableColumnType } from "@/enums/BTableColumnType";
import AnnoucementService from "@/services/porposal.service";
import { PermissionValue } from "@/enums/PermissionValue";
import { RowTable } from "@/typings/BRowTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import { ProposalState } from '@/enums/ProposalState';
import ResearchCenterBasicInformationComponent from "@/components/research-center-basic-information/researchCenterBasicInformation.vue"
import Porposal from '@/models/porposal/porposal.model';

@Component({
  components : {
    ResearchCenterBasicInformationComponent
  }
})
export default class PendingEvaluationsTableComponent extends GenericBTable<Porposal> {
    
    @Prop() public evaluationTypeId!: number; 

    annoucementId = null;
    codes = "";
    code = "";

    created() {
        this.tableConfig.controller = `Porposal/getPendingEvaluationsByEvaluationType/${this.evaluationTypeId}/AndUser/${this.user.id}`;
        this.formatColumns();
    }
    
    formatColumns() {
        let name = new BTableColumn("name", "table.proposal", true);
        let researchCenter = new BTableColumn("researchCenter", "table.researchCenter", true);
        let currentProposalState = new BTableColumn("currentProposalState", "table.estadoTitle", true);

        name.customTemplate = true;
        researchCenter.customTemplate = true;
        name.width = '400';
        researchCenter.width = '350';
        this.tableConfig.insertColumns(name, researchCenter, currentProposalState);
    
        this.tableConfig.actions.customTemplate = true;
        this.tableConfig.enableDefaultColumns = false;
    }

    @Watch("annoucementId")
    getByAnnoucement() {
        this.tableConfig.whereParams = `annoucementId eq  ${this.annoucementId}`;
        this.tableConfig.reload();
    }

    @Watch("code")
    getByCode() {
        this.tableConfig.whereParams = `contains(Code, '${this.code}')`;
        this.tableConfig.reload();
    }

    searchByCode(event: any) {
        if (event.keyCode === 13) {
        this.code = this.codes.trim();
        }
    }

    public verOpciones(row: Porposal) {
        this.$router.push(`/convocatoria/propuesta/${row.id}/evaluation/${this.evaluationTypeId}`);
    }
    
    get user() {
        return this.$store.state.user;
    }
}
